import styleMinimalist from './map-styles';

export default styleMinimalist;
